/**
 * Google Pay distinguishes between intents that fire DURING the wallet sheet
 * (dynamic pricing) and PAYMENT_AUTHORIZATION which fires AFTER user confirms.
 *
 * This distinction drives two key decisions:
 * - Whether to fire onPaymentDataChanged manually before the sheet opens
 * - Whether displayItems can be included in the request
 */

const DYNAMIC_PRICE_INTENTS = [
  "SHIPPING_OPTION",
  "SHIPPING_ADDRESS",
  "OFFER",
] as const;

export function hasDynamicPriceIntent(
  callbackIntents: string[] | undefined,
): boolean {
  return (callbackIntents ?? []).some((intent) =>
    (DYNAMIC_PRICE_INTENTS as readonly string[]).includes(intent),
  );
}

export function hasPaymentAuthorizationIntent(
  callbackIntents: string[] | undefined,
): boolean {
  return (callbackIntents ?? []).includes("PAYMENT_AUTHORIZATION");
}
